export default __webpack_public_path__ + "images/checkmark.688d064cdfa5a0ca643ada850ffaa3f4.svg";